export const DY_EVENT_NAME = {
  ADD_TO_CART: "Add to Cart",
  PURCHASE: "Purchase",
  REMOVE_FROM_CART: "Remove from Cart",
  LOGIN: "Login",
  SIGN_UP: "Signup",
  KEYWORD_SEARCH: "Keyword Search",
  NEWSLETTER: "Newsletter Subscription",
  SORT_ITEMS: "Sort Items",
  FILTER_ITEMS: "Filter Items",
};
